import { render } from "./JoinNow.vue?vue&type=template&id=519c5a72&scoped=true"
import script from "./JoinNow.vue?vue&type=script&lang=js"
export * from "./JoinNow.vue?vue&type=script&lang=js"

import "./JoinNow.vue?vue&type=style&index=0&id=519c5a72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-519c5a72"]])

export default __exports__